export default "__VITE_ASSET__CdBI3MNv__"